import type { Optional } from '@festina-life/core'
import { Alert, toast } from '@festina-life/ui/feedback'
import { FileInput } from '@festina-life/ui/forms'
import { useTranslate } from '@festina-life/ui/hooks'
import { Popover, PopoverButton } from '@festina-life/ui/structure'
import { useState } from 'react'

import { ActionsMenuPanel } from '../../../actionsPanel/ActionsMenuPanel'
import { OperationsLoadedButton } from '../../../operationsButton/OperationsLoadedButton'
import { useUploadWorkspacePackage } from './useUploadWorkspacePackage'

export const UploadWorkspaceButton = () => {
  const translate = useTranslate()
  const [files, setFiles] = useState<File[] | null>(null)
  const { parsedPackage, parseFile, upload, isUploading, error, reset } =
    useUploadWorkspacePackage()

  const handleFileChange = async (value: Optional<File[]>) => {
    setFiles(value?.length ? value : null)
    if (value?.length) {
      await parseFile(value[0])
    } else {
      reset()
    }
  }

  const handleUpload = async (close: () => void) => {
    const success = await upload()
    if (success) {
      toast({
        title: translate(
          'workspaceDetailsPanel.tabs.manage.uploadPackage.success',
        ),
        variant: 'success',
      })
      close()
      reset()
      setFiles(null)
    }
  }

  return (
    <Popover>
      {({ open, close }) => {
        if (!open && (files || error || parsedPackage)) {
          reset()
          if (files) {
            setFiles(null)
          }
        }

        return (
          <>
            <PopoverButton as="div">
              <OperationsLoadedButton startIcon="ArrowUpTray">
                {translate('workspaceDetailsPanel.tabs.manage.uploadPackage')}
              </OperationsLoadedButton>
            </PopoverButton>
            <ActionsMenuPanel
              anchor={{ to: 'right' }}
              className="flex flex-col gap-y-2"
            >
              <FileInput
                value={files}
                wrapperProps={{ label: undefined }}
                onChange={handleFileChange}
                onTouched={() => {}}
                accept=".json"
                multiple={false}
              />
              {error && <Alert severity="error">{error}</Alert>}
              <div className="flex justify-end">
                <OperationsLoadedButton
                  onClick={() => handleUpload(close)}
                  disabled={!parsedPackage || isUploading}
                >
                  {translate('workspaceDetailsPanel.tabs.manage.uploadPackage')}
                </OperationsLoadedButton>
              </div>
            </ActionsMenuPanel>
          </>
        )
      }}
    </Popover>
  )
}
